import controller_0 from '@symfony/ux-autocomplete/dist/controller.js';
import 'tom-select/dist/css/tom-select.default.css';
export default {
  'symfony--ux-autocomplete--autocomplete': controller_0,
};